import { type GetMetricGroupQueryParams } from '@gonfalon/openapi/operations/getMetricGroup';

import { createQueryHook } from '../internal/createQueryHook';
import { metricGroups } from '../queries/metrics';

/**
 * @deprecated Use `metricGroups.detail()` with `useQuery` directly.
 */
export const useMetricGroup = createQueryHook(
  ({
    projectKey,
    metricGroupKey,
    params,
  }: {
    projectKey: string;
    metricGroupKey: string;
    params?: GetMetricGroupQueryParams;
  }) => metricGroups.detail({ projectKey, metricGroupKey, params }),
);
